import React from 'react';
import './styles.css';
import { MessageElement, BupSpinner } from '@BUP/components';

const MessagesList = ({
  title,
  titleDark,
  titleIcon,
  messages,
  isLoading,
  error,
  handleSetMessageState
}) => {
  return (
    <div className="modebup-inbox-messages-list-container">
      <div 
        className="title-wrapper"
        style={titleDark ? {backgroundColor: '#767676'} : {}}
      >
        {titleIcon ?
          React.cloneElement(titleIcon, {
            className: `${titleIcon?.props?.className} title-icon`
          })
          : null
        }
        { title ? title : "Sin titulo"}
      </div>
      {
        isLoading ?
          (
            <div className="modebup-inbox-contents-wrapper">
              <BupSpinner size="medium" />
            </div>
          ) :
          error ?
            (
              <div className="modebup-inbox-contents-wrapper">
                <h3>Ocurrio un error al cargar los mensajes, por favor vuelve a intentarlo.</h3>
              </div>
            ) :
            messages && messages.length ?
              (
                <div className="modebup-inbox-messages-wrapper">
                  {
                    messages.map((message, idx) => (
                      <MessageElement
                        key={`modebup-inbox-message-${idx}`}
                        message={message}
                        handleSetMessageState={handleSetMessageState}
                      />
                    ))
                  }
                </div>
              ) :
              (
                <div className="modebup-inbox-contents-wrapper">
                  <h3>No tienes mesajes</h3>
                </div>
              )
      }

    </div>
  )
}

export default MessagesList;